import { BASE_URL } from '../constants';
import { errorHandling, errorHandler } from '../utils/errorHandling';
import { getItem } from '../utils/localStore';

class brokerConnectionTokenApi {
    static brokerConnecitonToken(data) {
        const TOKEN = getItem('auth_token');
        let isError = false;

        let brokerConnectionTokenData={
            hash : data.hash,
        }
        try{
            const ajaxRequestHeaders = new Headers({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Authorization': TOKEN
            });
            let body = {
                method: 'POST',
                headers: ajaxRequestHeaders,
                body:JSON.stringify(brokerConnectionTokenData)
            }
            return fetch(BASE_URL + 'auth/tradestation', body).then(response => {
                isError = errorHandling(response);
                return response.json();
            }).catch(error => {
                if (error && !isError) {
                    errorHandler(error);
                }
                return error;
            });
        }catch(err){
        }
    }
}

export default brokerConnectionTokenApi;